import { render, staticRenderFns } from "./PrintRecordList.vue?vue&type=template&id=30589848"
import script from "./PrintRecordList.vue?vue&type=script&lang=js"
export * from "./PrintRecordList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports